import { StatusKeys } from './types';

export const getColorByStatus = (status: StatusKeys) => {
  switch (status) {
    case StatusKeys.Planning: return '#01B3C5';
    case StatusKeys.Recording: return '#EFC400';
    case StatusKeys.ReadyToEdit: return '#F37A21';
    case StatusKeys.Editing: return '#8324B2';
    case StatusKeys.ReadyForOpsReview: return '#d20986';
    case StatusKeys.ReadyForCustomerReview: return '#0B72D5';
    // case Statuses.Rejected: return '#EE4D23';
    case StatusKeys.Approved: return '#7CAF42';
    case StatusKeys.Publishing: return '#747C99';
    case StatusKeys.Published: return '#26325F';
    default: return '#000';
  }
};
